var map = {
	"./africa.png": 1421,
	"./asia.png": 1422,
	"./australia.png": 1423,
	"./blurry-map-preview.png": 764,
	"./brandbook-half-o-bottom.svg": 648,
	"./brandbook-half-o-side.svg": 647,
	"./doc.svg": 765,
	"./europe.png": 1424,
	"./file.svg": 766,
	"./icons/NFC.svg": 439,
	"./icons/QR.svg": 440,
	"./icons/cloud-slash.svg": 444,
	"./icons/file-slash.svg": 445,
	"./icons/no-data.svg": 437,
	"./ion-rangeslider/sprite-skin-flat.png": 643,
	"./jstree/32px.png": 644,
	"./jstree/40px.png": 646,
	"./jstree/throbber.gif": 645,
	"./logo.png": 433,
	"./logo_light.png": 667,
	"./maestrocard.png": 756,
	"./mastercard.png": 1425,
	"./mastercard2.png": 755,
	"./north-america.png": 1426,
	"./ondato-logo.svg": 434,
	"./owl.carousel/ajax-loader.gif": 1427,
	"./owl.carousel/owl.video.play.png": 642,
	"./paypal.png": 757,
	"./picture.gif": 1428,
	"./south-america.png": 1429,
	"./spec-bg.png": 675,
	"./visa.png": 754
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1420;